import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import Translate from 'modules/local/Translate'

import React, {useContext} from 'react'
import {Link} from 'react-router-dom'
import {NullAsDefault, renderIf} from 'views/Shared'
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {GoDotFill} from "react-icons/go";
import {renderIfElse} from "../../../Shared";
import {ItemInformation} from "../../../AppLocals/Organization/OrganizationEntity";
import {formatSimplifyDate} from "../../../../helpers/dateUtils";
import {formatDate} from "../../../../helpers/datetimeHelpers";

export const renderCourseClass = ({detail = true, renderContextMenu = NullAsDefault} = {}) => (item, index) => {
    const {
        course,
        to_date,
        from_date,
        description,
        coordinators = [],
        timetable_nexts = [],
        number_of_students,
    } = item ?? {}

    const {start_time, location_address} = timetable_nexts[0] ?? {}

    const {isSm} = useContext(LayoutContext)

    const renderNextLesson = (time, location) => (
        <Translate>
            {(t) => (
                <span className="space-x-1">
                    <span style={{fontSize: 11}} className="font-bold text-green-600 capitalize tracking-wide">
                        {formatSimplifyDate(time, 'fullTime')}
                    </span>
                    {renderIf(
                        location,
                        <React.Fragment>
                            <span className="text-xs text-color-500">{t('in')}</span>
                            <span style={{fontSize: 11}} className="font-semibold text-color-100 tracking-wide">
                                {location}
                            </span>
                        </React.Fragment>
                    )}
                </span>
            )}
        </Translate>
    )

    return renderIf(
        item,
        <Translate key={index}>
            {(t) => (
                <div
                    className="px-0 md:px-2 py-2 flex flex-col gap-1 rounded-lg custom-item-render custom-render-border relative">
                    <Link
                        to={getLinkToDetail(item)}
                        className="font-bold text-base text-color-000 no-underline leading-snug">
                        {getTitle(item)}
                    </Link>
                    <div className="space-x-1 text-xs italic leading-tight">
                        <GoDotFill size={10} className="text-color-400"/>
                        {renderIf(
                            !isSm,
                            <span className="text-color-500">
                            {t('belong to the course')}
                        </span>
                        )}
                        <Link
                            to={getLinkToDetail(course)}
                            className="font-bold text-blue-500 no-underline">
                            {getTitle(course)}
                        </Link>
                        {renderIf(
                            _.some([from_date, to_date]),
                            <span className="space-x-1 text-2xs md:text-xs italic">
                            <span className="text-color-500">{isSm ? `(` : ` - ${t('from date')}`}</span>
                            <span className="font-bold text-color-000">{formatDate(from_date,'DD/MM/YYYY')}</span>
                            <span className="text-color-500">{isSm ? '-' : t('to')}</span>
                            <span className="font-bold text-color-000">{formatDate(to_date, 'DD/MM/YYYY')}</span>
                            <span className="text-color-500">{isSm && ' ) '}</span>
                        </span>
                        )}
                    </div>
                    {renderIf(
                        coordinators.length > 0,
                        <span className="space-x-1 leading-tight">
                        <GoDotFill size={10} className="text-color-400"/>
                        <span className="space-x-1 text-xs italic">
                            <span className="text-color-500">{`${t('class coordinator')} : `}</span>
                            {renderIfElse(
                                coordinators.length > 0,
                                coordinators.map((e, i) => (
                                    <span key={i} className="font-semibold text-color-100">
                                        {e?.teacher?.prefix_title || ''} {e?.teacher_name} {i < coordinators.length - 1 && ', '}
                                    </span>
                                )),
                                <span className="font-medium text-color-300">{`${t('not update')}...`}</span>
                            )}
                        </span>
                    </span>
                    )}
                    <ItemInformation showIcon={true} label="the next lesson"
                                     value={renderNextLesson(start_time, location_address)} className="text-xs italic"/>
                    {renderIf(
                        detail && description,
                        <div className="max-lines-2 text-xs text-color-400 italic">
                            {description}
                        </div>
                    )}
                    <div className="absolute right-0 top-5 contextIcon">
                        {renderContextMenu(item)}
                    </div>
                </div>
            )}
        </Translate>
    )
}
